import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface CategoryFilterProps {
  categories: string[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

export function CategoryFilter({ categories, activeCategory, onCategoryChange }: CategoryFilterProps) {
  return (
    <div className="flex flex-wrap items-center justify-center gap-2 mb-12">
      <button
        onClick={() => onCategoryChange("Todos")}
        className={cn(
          "px-6 py-2 rounded-full text-xs font-black uppercase tracking-widest transition-all border",
          activeCategory === "Todos"
            ? "bg-electric border-electric text-white shadow-[0_0_20px_rgba(0,186,255,0.4)]"
            : "bg-white/5 border-white/10 text-muted-foreground hover:border-white/20 hover:text-white"
        )}
      >
        Todos
      </button>
      {categories.map((category) => (
        <button
          key={category}
          onClick={() => onCategoryChange(category)}
          className={cn(
            "px-6 py-2 rounded-full text-xs font-black uppercase tracking-widest transition-all border",
            activeCategory === category
              ? "bg-electric border-electric text-white shadow-[0_0_20px_rgba(0,186,255,0.4)]"
              : "bg-white/5 border-white/10 text-muted-foreground hover:border-white/20 hover:text-white"
          )}
        >
          {category}
        </button>
      ))}
    </div>
  );
}